import {
    Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
    ModalCloseButton, useToast, Text
} from '@chakra-ui/react';

export const DeleteRoomModal = ({ isOpen, onClose, onSuccess, currentRoom }: {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    currentRoom?: { luogo: string; data: string; titoloEvento?: string };
}) => {
    const toast = useToast();

    const handleDelete = async () => {
        if (!currentRoom) {
            toast({ status: 'warning', title: 'Nessuna sala selezionata' });
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/delete-room?section=${currentRoom.luogo}&date=${currentRoom.data}`,
                {
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            const data = await res.json();
            if (!res.ok) throw new Error(data.message || 'Errore');

            onClose();
            toast({ status: 'success', title: data.message });
            onSuccess();

        } catch (err) {
            toast({ status: 'error', title: 'Errore durante l\'eliminazione', description: `${err}` });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Elimina Sala</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {currentRoom ? (
                        <>
                            <Text mb={2}>Sei sicuro di voler eliminare questa sala?</Text>
                            <Text fontWeight="bold" mt={4}>Evento: {currentRoom.titoloEvento || 'N/A'}</Text>
                            <Text>Luogo: {currentRoom.luogo}</Text>
                            <Text>Data: {new Date(currentRoom.data).toLocaleDateString('it-IT')}</Text>
                        </>
                    ) : (
                        <Text>Nessuna sala selezionata</Text>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="red" onClick={handleDelete} isDisabled={!currentRoom} mr={3}>
                        Elimina
                    </Button>
                    <Button variant="ghost" onClick={onClose}>Annulla</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};